export type Page = {
  documentId: string
  name: string
  slug: string
  blocks?: any[] | null
  pageType: PageType | null | false
}

export enum PageType {
  Store = 'store',
  Classifieds = 'ads',
}
